/**
 * Default translations for wallet notification content
 * These are used to initialize wallet notification nodes with pre-translated content
 * for all supported languages.
 */

export const DEFAULT_WALLET_TITLES: Record<string, string> = {
  en: "Your package is on its way",
  fr: "Votre colis est en cours de livraison",
  es: "Su paquete está en camino",
  de: "Ihr Paket ist unterwegs",
  it: "Il tuo pacco è in arrivo",
  pt: "Seu pacote está a caminho",
  nl: "Uw pakket is onderweg",
  pl: "Twoja paczka jest w drodze",
  sv: "Ditt paket är på väg",
  da: "Din pakke er på vej",
  no: "Pakken din er på vei",
  fi: "Pakettisi on matkalla",
  cs: "Váš balík je na cestě",
  ro: "Pachetul dvs. este în drum",
  hu: "A csomagja úton van",
  sk: "Váš balík je na ceste",
  bg: "Вашата пратка е в движение",
  hr: "Vaš paket je na putu",
  sl: "Vaš paket je na poti",
  et: "Teie pakett on teel",
  lv: "Jūsu sūtījums ir ceļā",
  lt: "Jūsų siunta kelyje",
  el: "Το δέμα σας βρίσκεται καθ' οδόν",
  tr: "Paketiniz yolda",
  ru: "Ваша посылка в пути",
  uk: "Ваша посилка в дорозі",
  ja: "お荷物は配送中です",
  zh: "您的包裹正在运送中",
  ko: "귀하의 소포가 배송 중입니다",
  ar: "طردك في الطريق",
  he: "החבילה שלך בדרך",
  th: "พัสดุของคุณกำลังเดินทาง",
  vi: "Gói hàng của bạn đang trên đường",
  id: "Paket Anda dalam perjalanan",
  ms: "Bungkusan anda sedang dalam perjalanan",
};

export const DEFAULT_WALLET_TEXTS: Record<string, string> = {
  en: "Track your shipment",
  fr: "Suivez votre envoi",
  es: "Rastrea tu envío",
  de: "Verfolgen Sie Ihre Sendung",
  it: "Traccia la tua spedizione",
  pt: "Rastreie seu envio",
  nl: "Volg uw zending",
  pl: "Śledź swoją przesyłkę",
  sv: "Spåra din leverans",
  da: "Spor din forsendelse",
  no: "Spor forsendelsen din",
  fi: "Seuraa lähetystäsi",
  cs: "Sledujte svou zásilku",
  ro: "Urmăriți livrarea",
  hu: "Kövesse csomagját",
  sk: "Sledujte svoju zásielku",
  bg: "Проследете пратката си",
  hr: "Pratite svoju pošiljku",
  sl: "Sledite svoji pošiljki",
  et: "Jälgige oma saadetist",
  lv: "Sekojiet savam sūtījumam",
  lt: "Sekite savo siuntą",
  el: "Παρακολουθήστε την αποστολή σας",
  tr: "Gönderinizi takip edin",
  ru: "Отследите вашу посылку",
  uk: "Відстежте вашу посилку",
  ja: "配送を追跡する",
  zh: "追踪您的货物",
  ko: "배송 추적하기",
  ar: "تتبع شحنتك",
  he: "עקוב אחרי המשלוח",
  th: "ติดตามพัสดุของคุณ",
  vi: "Theo dõi lô hàng của bạn",
  id: "Lacak pengiriman Anda",
  ms: "Jejaki penghantaran anda",
};

export function getDefaultWalletTitle(
  locale: string,
  defaultLocale: string,
): string {
  return (
    DEFAULT_WALLET_TITLES[locale] ||
    DEFAULT_WALLET_TITLES[defaultLocale] ||
    DEFAULT_WALLET_TITLES.en ||
    "Your package is on its way"
  );
}

export function getDefaultWalletText(
  locale: string,
  defaultLocale: string,
): string {
  return (
    DEFAULT_WALLET_TEXTS[locale] ||
    DEFAULT_WALLET_TEXTS[defaultLocale] ||
    DEFAULT_WALLET_TEXTS.en ||
    "Track your shipment"
  );
}
